import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { wccExportApi } from './api';
import { DownloadFileDto } from '@sr/dto/dist/src/download-file.dto';

export const useWccExport = () => {
  const [postExport, { data, isLoading, error, reset }] = wccExportApi.useRunExportMutation();

  const runExport = async (idList: number[]): Promise<DownloadFileDto[]> => {
    if (idList.length === 0) return Promise.reject(new Error('Нет актов для экспорта'));

    return postExport(idList).unwrap();
  }

  return {
    runExport,
    report: data || null,
    loading: isLoading,
    error: extractNestJsErrorMessage(error),
    reset
  }
}